export class NotStartedError extends Error {
	constructor() {
		super("Not started");
	}
}
